import React from "react";
import DataTable from "Components/New/DataTable/DataTable/DataTable";
import DataProvider from "Components/New/DataProvider/DataProvider";
import localize from "helpers/localize";

class ClientUsers extends React.Component {
  render() {
    const { client, readOnly, afterSave } = this.props;
    if (!client) {
      return "Betöltés...";
    }
    return (
      <div style={{ width: "100%", position: "relative" }}>
        <DataProvider
          url={"user-clients"}
          queryParams={{
            section: "users",
            client_id: client.id
          }}
          //optionsUrl={`user-clients/options`}
          component={DataTable}
          onlyBasefieldsOnForm
          title={localize("clients", "Felhasználók")}
          filterable={false}
          readOnly={readOnly}
          canEdit={false}
          afterSave={afterSave}
          goBackAfterSave
          perPage={1000}
          options={{
            grid: {
              columns: {
                client_name: {
                  hidden: true
                }
              }
            },
            form: {
              baseFields: {
                //name: { validators: ["required"] },
                //zip: { validators: ["required"] },
                client_id: {
                  name: localize("clients", "Ügyfél"),
                  validators: ["required"],
                  defaultValue: client.id,
                  hidden: true
                },
                user_id: {
                  name: localize("clients", "Felhasználó"),
                  validators: ["required"]
                }
              }
            }
          }}
        />
      </div>
    );
  }
}

export default ClientUsers;



// WEBPACK FOOTER //
// ./src/Containers/Pages/Clients/views/ClientUsers.js